import React from 'react';
import { Link } from 'react-router-dom';
import '../../Styles/PageNotFound/PageNotFound.css';

const PageNotFound = () => {
    return (
        <div className="page-not-found-main-container">
            <div className="page-not-found-gif-wrapper">
                <img className="page-not-found-gif" src={process.env.PUBLIC_URL + '/Images/errorPageGif.gif'} alt="Gif" />
            </div>
            <div className="page-not-found-headings-wrapper flex-box">
                <h1>Page Not Found</h1>
                <h3 className="flex-box">
                    Got lost?
                    <span>
                        <Link to="/">Hit me</Link>
                    </span>
                </h3>
            </div>
        </div>
    )
}

export default PageNotFound
